<template>
  <div>
    <b-card class="text-center">
      <h1>{{ Title || 'No Data' }}</h1>
      <div>
        <p>{{ Description || 'Please connect your wallet, and Ceramic/IPFS.' }}</p>
        <wallet-connector></wallet-connector>
      </div>
    </b-card>
  </div>
</template>
<script>
import WalletConnector from "../components/WalletConnector.vue";
export default {
  name: "blank",
  components: { WalletConnector },
  props: ["Title", "Description"],
};
</script>